import React, { useCallback, useEffect, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import BrandShowcase from "@/components/site/BrandShowcase";
import About from "@/components/site/About";
import ArtUpload from "@/components/site/ArtUpload";
import ProductsSection from "@/components/site/ProductsSection";
import Differentials from "@/components/site/Differentials";
import Gallery from "@/components/site/Gallery";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import Clients from "@/components/site/Clients";
import FaqSection from "@/components/site/FaqSection";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import WhatsappFloat from "@/components/site/WhatsappFloat";
import QuoteDialog from "@/components/site/QuoteDialog";

export default function Home() {
  const [open, setOpen] = useState(false);
  const [defaultProduct, setDefaultProduct] = useState(undefined);

  const openQuote = useCallback((product) => {
    if (typeof product === "string") setDefaultProduct(product);
    setOpen(true);
  }, [setDefaultProduct, setOpen]);

  // Acompanha o scroll pelo Hero para deixar o cabeçalho gradualmente sólido
  // (--header-solid, 0→1 — ver index.css), chegando a 100% sólido em 50% da
  // altura do Hero. rAF-throttled para não rodar a cada evento de scroll.
  useEffect(() => {
    document.body.classList.add("mn-hero-active");
    const heroEl = document.querySelector('[data-testid="hero-section"]');
    let rafId = null;

    const applyProgress = () => {
      rafId = null;
      const heroHeight = heroEl?.offsetHeight || window.innerHeight;
      const progress = Math.min(1, Math.max(0, window.scrollY / (heroHeight * 0.5)));
      document.documentElement.style.setProperty("--header-solid", progress.toFixed(3));
    };
    const onScroll = () => {
      if (rafId === null) rafId = requestAnimationFrame(applyProgress);
    };

    applyProgress();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      if (rafId !== null) cancelAnimationFrame(rafId);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      document.documentElement.style.removeProperty("--header-solid");
      document.body.classList.remove("mn-hero-active");
    };
  }, []);

  return (
    <div className="App" data-testid="home-page">
      <Header onQuoteClick={() => openQuote()} />
      <main>
        <Hero onQuoteClick={() => openQuote()} />
        <BrandShowcase onQuoteClick={() => openQuote()} />
        <About onQuoteClick={() => openQuote()} />
        <ArtUpload onQuoteClick={() => openQuote()} />
        <ProductsSection onQuoteClick={(name) => openQuote(name)} />
        <Differentials />
        <Gallery />
        <Process />
        <Testimonials />
        <Clients />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsappFloat />
      <QuoteDialog open={open} onOpenChange={setOpen} defaultProduct={defaultProduct} />
    </div>
  );
}
